<script lang="ts">
    import type { InterviewBlockFragment } from '$gen/graphql';

    export let content: InterviewBlockFragment;

    $: interviewee = content?.interviewee[0];
    $: interviewer = content?.interviewer[0];

    type Result = {
        initials: string | undefined;
        textWithoutInitials: string;
    };

    function hasInitials(text: string): Result | null {
        const result = text.split(/^(\[[a-zA-Z]{2,3}\])/);
        const initials =
            result.length > 1 && result[1].startsWith('[') && result[1].endsWith(']')
                ? result[1].replace('[', '').replace(']', '')
                : undefined;
        const textWithoutInitials = initials && result.length > 2 ? result[2] : text;

        if (initials && textWithoutInitials) {
            return { initials, textWithoutInitials };
        } else {
            return null;
        }
    }
</script>

<section class="grid columns-1 justify-items-center leading-5 md:text-xl md:leading-6">
    {#each content.questionsAndAnswers as { question, answer }}
        {@const questionOverwrite = hasInitials(question)}
        {@const answerOverwrite = hasInitials(answer)}
        {#if question}
            <p class="italic md:w-2/3 lg:w-1/2">
                {#if questionOverwrite}
                    <span class="mr-2">{questionOverwrite.initials}</span>
                    {questionOverwrite.textWithoutInitials}
                {:else}
                    <span title={interviewer?.fullName} class="mr-2">{interviewer?.initials}</span>
                    {question}
                {/if}
            </p>
        {/if}
        {#if answer}
            <p class="pl-10 md:w-2/3 md:pl-24 lg:w-1/2 lg:pl-32 xl:pl-40">
                {#if answerOverwrite}
                    <span class="mr-2">{answerOverwrite.initials}</span>
                    {answerOverwrite.textWithoutInitials}
                {:else}
                    <span class="mr-2" title={interviewee?.fullName}>{interviewee?.initials}</span>
                    {answer}
                {/if}
            </p>
        {/if}
    {/each}
    <p class="md:w-2/3 lg:w-1/2" />
</section>
